module.exports = __webpack_public_path__ + "static-portal/img/bg-2.fw.9c57832.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-2.fw.png
// module id = TqV0
// module chunks = 4